import { render, staticRenderFns } from "./PolygonWallet.vue?vue&type=template&id=1e9bd6ce&scoped=true"
import script from "./PolygonWallet.vue?vue&type=script&lang=js"
export * from "./PolygonWallet.vue?vue&type=script&lang=js"
import style0 from "./PolygonWallet.vue?vue&type=style&index=0&id=1e9bd6ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9bd6ce",
  null
  
)

export default component.exports